import { makeAutoObservable } from "mobx";
import {
    getAllDrugInteractions,
    pagingDrugInteractions,
    getDrugInteractionsById,
    deleteDrugInteractionsById,
    saveOrUpdate,
    saveDrugInteractionSyncStore
} from 'app/services/DrugInteractionsService';

import { SearchObject } from "app/common/Model/SearchObject";
import { toast } from "react-toastify";
import { DrugInteractions } from "app/common/Model/DrugInteractions";
import { checkSearchObject } from "app/common/LocalFunction";

export default class DrugInteractionsStore {
    listAllDrugInteractions = [];
    searchDrugInteractions = new SearchObject();
    pageDrugInteractions = null;
    selectedDrugInteractions = null;
    openFormCreateOrEdit = false;
    openConfirmDelete = false;
    recentlyUpdated = false;
    openSyncStore = false

    constructor() {
        makeAutoObservable(this);
    }

    getAllDrugInteractions = async (unitType) => {
        if (this.listAllDrugInteractions?.length === 0 || this.recentlyUpdated) {
            const searchObjectForAll = {
                pageSize: 1000000,
                pageIndex: 1,
                unitType: unitType,
            };

            pagingDrugInteractions(searchObjectForAll)
                .then(({ data }) => {
                    this.listAllDrugInteractions = data?.content;
                    this.recentlyUpdated = false;
                })
                .catch((error) => {
                    console.error(error);
                    toast.error("Lấy dữ liệu thuốc có lỗi")
                })
        }
    }


    pagingDrugInteractions = async () => {
        return await pagingDrugInteractions(this.searchDrugInteractions)
            .then(({ data }) => {
                this.pageDrugInteractions = data;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lấy dữ liệu có lỗi")
            })
    }

    handleChangeFormSearch = (searchDrugInteractions) => {
        this.searchDrugInteractions = checkSearchObject(this.searchDrugInteractions, searchDrugInteractions);
        this.pagingDrugInteractions();
    }

    handleOpenFormCreateOrEdit = (drugInteractionsId) => {
        if (Boolean(drugInteractionsId)) {
            getDrugInteractionsById(drugInteractionsId).then(({ data }) => {
                this.selectedDrugInteractions = data;
                this.openFormCreateOrEdit = true;
            })
        } else {
            this.selectedDrugInteractions = new DrugInteractions();
            this.openFormCreateOrEdit = true;
        }
    }

    saveDrugInteractions = async (drugInteractions, { setSubmitting }) => {
        try {
            const { data } = await saveOrUpdate(drugInteractions);
            if (data) {
                this.selectedDrugInteractions = null;
                this.pagingDrugInteractions();
                this.handleClosePopup();
                this.recentlyUpdated = true;

                toast.success("Lưu bản ghi thành công!");
            }
        } catch {
            toast.error("Lưu bản ghi thất bại!");
        } finally {
            setSubmitting(false);
        }
    };

    handleDelete = (drugInteractions) => {
        this.selectedDrugInteractions = { id: drugInteractions?.id };
        this.openConfirmDelete = true;
    }

    handleConfirmDelete = async () => {
        return await deleteDrugInteractionsById(this.selectedDrugInteractions?.id)
            .then(() => {
                if (this.searchDrugInteractions?.pageIndex > 1 && this.pageDrugInteractions?.content?.length === 1) {
                    this.searchDrugInteractions.pageIndex -= 1;
                }
                toast.success("Xóa bản ghi thành công!");
                this.handleClosePopup();
                this.pagingDrugInteractions();
                this.recentlyUpdated = true;
            })
            .catch(err => {
                console.error(err);
                toast.error("Xóa bản ghi có lỗi");
            })
    }

    handleClosePopup = () => {
        this.openFormCreateOrEdit = false;
        this.openConfirmDelete = false;
    }

    handleOpenSyncStore = () => {
        this.openSyncStore = true
    }

    handleCloseSyncStore = () => {
        this.openSyncStore = false
    }

    handleSaveSyncStore = (data, { setSubmitting }) => {
        saveDrugInteractionSyncStore(data).then(() => {
            this.openSyncStore = false;
            toast.success("Đồng bộ thuốc thành công")
            this.pagingDrugInteractions()
        }).catch((err) => {
            toast.error("Đồng bộ thuốc thất bại")
        }).finally(() => {
            setSubmitting(false)
        })
    }

    resetStore = () => {
        this.searchDrugInteractions = new SearchObject();
        this.pageDrugInteractions = null;
        this.selectedDrugInteractions = null;
        this.openFormCreateOrEdit = false;
        this.openConfirmDelete = false;
    }
}
